<mat-card
	(@slideContent.done)="onAnimationDone($event)"
	(@slideContent.start)="onAnimationStart($event)"
	[@slideContent]="animationState"
	class="calendar-range-picker-container !p-0"
>
	<mat-card-content>
		<div class="flex flex-row items-start justify-start max-[690px]:flex-col">
			<!-- list for range presets-->
			<div
				*ngIf="allowDynamic.value && this.ranges$Custom | async as ranges"
				class="range-container flex-col wflex-[1_1_120px] max-[690px]:w-full max-[690px]:flex-row max-[690px]:gap-2"
				mat-list
			>
				<!-- Current/Now presets -->
				<div class="flex flex-col max-[690px]:flex-1">
					<div class="pl-3 pb-1">{{ 'time-range.presetsNow' | translate }}</div>
					<ng-container *ngFor="let item of ranges | slice: 0 : 5">
						<button
							(click)="this.selectRange(item)"
							[class.active]="(this.range$ | async)?.name === item.name"
							class="range-item px-2 py-1 flex justify-center items-center w-full max-[690px]:text-xs max-[690px]:py-0.5"
							mat-menu-item
						>
							<div class="flex flex-row items-center">
								<span class="text-sm">{{ item.name | translate }}</span>
							</div>
						</button>
					</ng-container>
				</div>

				<mat-divider
					class="w-full my-2 pb-2 max-[690px]:!hidden"
					style="margin-top: 3px"
				></mat-divider>
				<mat-divider
					class="self-stretch mx-1 min-[676px]:!hidden"
					vertical
				></mat-divider>

				<!-- Past presets -->
				<div class="flex flex-col max-[690px]:flex-1">
					<div class="pl-3 pt-1 pb-1 front-size:1.5rem max-[690px]:pt-0">
						{{ 'time-range.presetsPast' | translate }}
					</div>
					<ng-container *ngFor="let item of ranges | slice: 5 : 10">
						<button
							(click)="this.selectRange(item)"
							[class.active]="(this.range$ | async)?.name === item.name"
							class="range-item px-2 py-1 flex justify-center items-center w-full max-[690px]:py-0.5"
							mat-menu-item
						>
							<div class="flex flex-row items-center">
								<span class="text-sm">{{ item.name | translate }}</span>
							</div>
						</button>
					</ng-container>
				</div>
			</div>

			<mat-divider
				class="self-stretch mx-2 max-[690px]:hidden"
				vertical
			></mat-divider>
			<mat-divider class="w-full my-2 min-[676px]:hidden"></mat-divider>

			<!-- rightside-->
			<div class="flex flex-col max-[690px]:w-full">
				<!-- clander div -->
				<div class="flex flex-row max-[690px]:flex-col max-[690px]:items-center">
					<div class="p-1">
						<mat-calendar
							(selectedChange)="this.selectedChange($event, true)"
							[maxDate]="maxDate.value"
							[minDate]="minDate.value"
							[selected]="calendarValue.value$ | async"
							#startCal
							class="calendar-start-date-item calender-item"
							color="primary"
						></mat-calendar>
					</div>
					<div class="p-1">
						<mat-calendar
							(selectedChange)="this.selectedChange($event, false)"
							[maxDate]="maxDate.value"
							[minDate]="minDate.value"
							[selected]="calendarValue.value$ | async"
							#endCal
							class="calendar-end-date-item calender-item"
							color="primary"
						></mat-calendar>
					</div>
				</div>
				<div
					*ngIf="errorValue.value"
					class="flex flex-ro pl-5 pb-2 text-warn"
				>
					<span>{{ 'errors.' + errorValue.value | translate }}</span>
				</div>
				<!-- date input div-->
				<div class="flex flex-row items-center gap-4 max-[690px]:flex-col max-[690px]:gap-1">
					<div class="p-1 pl-5 flex-1 max-[690px]:w-full max-[690px]:pl-1">
						<mat-form-field class="example-full-width pt-1 pb-1">
							<input
								(blur)="this.selectedChange($event.target.value, true)"
								[disabled]="!startDate.value"
								[placeholder]="!startDate.value ? startDatePlaceholder.value : ('time-range.startDate' | translate)"
								[value]="startDate.value | formatDate"
								matInput
							>
							<mat-hint
								[ngClass]="{ 'cursor-default': true }"
								*ngIf="!this.rangeStrategy$.value || this.rangeStrategy$.value == 'flex'"
							>
								{{ usersDateFormat.value }}
							</mat-hint>
						</mat-form-field>
					</div>
					<div
						*ngIf="calendarValue.value$ | async as range"
						class="p-1 pl-3 flex-1 max-[690px]:w-full max-[690px]:pl-1"
					>
						<mat-form-field class="example-full-width pt-1 pb-1">
							<input
								(blur)="this.selectedChange($event.target.value, false)"
								[disabled]="!endDate.value"
								[placeholder]="!endDate.value ? endDatePlaceholder.value : ('time-range.endDate' | translate)"
								[value]="endDate.value | formatDate"
								matInput
							>
							<mat-hint
								[ngClass]="{ 'cursor-default': true }"
								*ngIf="!this.rangeStrategy$.value"
							>
								{{ usersDateFormat.value }}
							</mat-hint>
						</mat-form-field>
						<ng-container *ngIf="(this.ranges$Custom | async)[10] as item">
							<mat-checkbox
								(change)="rangeStrategy$.value != 'flex' ? selectRange({ rangeType: item.rangeType, name: item.name, from: null, to: item.to }) : selectRange({ rangeType: null, name: null, from: this.startDate.value, to: range.end })"
								[checked]="rangeStrategy$.value === 'flex'"
								[matTooltip]="'time-range.generalize' | translate"
								*ngIf="(allowDynamic.value && allowGeneralize.value) && isToday(calendarValue.value$ | async) && (!this.rangeStrategy$.value || this.rangeStrategy$.value == 'flex')"
							></mat-checkbox>
						</ng-container>
					</div>
				</div>
				<!-- apply button div-->
				<div
					*ngIf="this.range$ | async as r"
					class="flex flex-row items-center justify-end gap-[14px] pt-1 pr-4 pb-3 max-[690px]:pr-1 max-[690px]:flex-col max-[690px]:items-stretch"
				>
					<span
						*ngIf="r.from >= r.to"
						class="text-warn max-[690px]:text-center"
						>{{
							'errors.record.time-invalid-range' | translate
						}}</span
					>
					<button
						(click)="this.saveSelection()"
						[disabled]="!r.from || !r.to || r.from >= r.to"
						class="max-[690px]:w-full"
						color="primary"
						mat-raised-button
					>
						{{ 'utils.apply' | translate }}
					</button>
				</div>
			</div>
		</div>
	</mat-card-content>
</mat-card>

<ng-template #defaultDayViewTemplate>
	<span
		*ngIf="rangeStart$ | async as dt"
		class="time-range-display-start"
		>{{
			dt | formatDate: 'PP'
		}}</span
	>
	<span class="time-range-display-divider">-</span>
	<span
		*ngIf="rangeEnd$ | async as dt"
		class="time-range-display-end"
		>{{
			dt | formatDate: 'PP'
		}}</span
	>
</ng-template>

<ng-template #sameDayTemplate>
	<div class="time-range-display flex flex-row items-center justify-center text-center">
		<span class="time-range-display-start">{{ this.rangeStart$ | async | formatDate: 'PP' }}</span>
	</div>
</ng-template>
